import axios from "axios";
import { API_URL, getHeaders } from "../config";

/**
 * Per-content resume/progress. Both calls are best-effort: any failure is
 * swallowed so the player/viewers never break if progress can't be saved or
 * fetched. Purely additive — does not affect the existing history endpoints.
 */
export const getProgress = async (contentType, contentId) => {
  try {
    const { data } = await axios.get(
      `${API_URL}/api/progress?contentType=${contentType}&contentId=${contentId}`,
      { headers: getHeaders().headers }
    );
    return data?.data || null;
  } catch (e) {
    return null;
  }
};

/**
 * Report OBSERVATIONS (dwell, pages reached, playback advanced). The server
 * evaluates them and returns its verdict — the client never asserts completion.
 * Returns the verdict, or null if the beat couldn't be delivered.
 */
export const saveProgress = async (payload) => {
  try {
    const { data } = await axios.post(`${API_URL}/api/progress`, payload, {
      headers: getHeaders().headers,
    });
    return data?.data || null;
  } catch (e) {
    /* best-effort */
    return null;
  }
};
